import React, { useState, useEffect } from "react";

import {
  Typography,
  TextField,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  FormLabel,
  InputAdornment,
  CircularProgress,
  Tooltip,
  IconButton,
  OutlinedInput,
} from "@mui/material";
import es from "date-fns/locale/es";

//components @mui/x-date-pickers
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

import { ObtenerListadoRegistrosGenericos } from "../../../Actions/Utilidades/CodigosSistemaAction";
import { ObtenerListadoCamposDinamicosRadios } from "../../../Actions/Utilidades/CamposDinamicosAction";
import { useStateValue } from "../../../Contexto/store";
import InputMask from "react-input-mask";
import AccionesUsuario from "../../../Configuracion/Llaves/AccionesUsuario";
import { enlistaArrayCodigosMensajesIdiomas } from "../../../Actions/Generales/IdiomasAction";
import { MostrarMensaje } from "../../../Utilidades/ManejoMensajes";
import { getFormatDateLocalStorage } from "../../../Utilidades/LeerInfoLocalStorage";
import {
  DescargarArchivoBase64,
  RutinaLeerArchivoInputFile,
  ValidarFormatoArchivo,
} from "../../../Utilidades/ManejoArchivos";

//Material Icons
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import BackupOutlinedIcon from "@mui/icons-material/BackupOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import {
  BajarArchivosServidor,
  EliminarArchivosServidor,
  SubirArchivosServidor,
} from "../../../Actions/Utilidades/ManejoArchivosAction";

const idioma = localStorage.getItem("etiqueta_idioma") || "ES";

const InputsField = ({
  CampoDinamico,
  IdRelacionado,
  SectionId,
  SubModuloId,
  Elemento = "",
}) => {
  const [{ sesionUsuario }] = useStateValue();

  //variable de estado local para las propiedades del componente
  const [campoX, setCampoX] = useState(CampoDinamico);
  const [listado, setListado] = useState([]);
  const [check, setCheck] = useState(false);

  useEffect(() => {
    ObtenerLista();
  }, [IdRelacionado]);

  const ObtenerLista = async () => {
    if (
      campoX.typeField === "LIST" ||
      campoX.typeField === "MULT_LIST" ||
      campoX.typeField === "RADIO"
    ) {
      campoX.dataField = campoX.dataField.toLowerCase();
      setCampoX(campoX);
      const response = await ObtenerListadoRegistrosGenericos(
        campoX.listRecords,
        "",
        sesionUsuario.usuario.companyId,
        sesionUsuario.usuario.userId,
        "",
        true
      );
      if (response.status === 200) {
        setListado(response.data);
      } else {
        if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
        setListado([]);
      }
    }
    // else if (campoX.typeField === 'RADIO') {
    //     campoX.dataField = campoX.dataField.toUpperCase();
    //     setCampoX(campoX);
    //     // const Params = {
    //     //     SectionId: SectionId,
    //     //     FileName: campoX.fieldName,
    //     //     IdRel: IdRelacionado,
    //     //     PeticionUsuario: {
    //     //         CompanyId: sesionUsuario.usuario.companyId,
    //     //         UserId: sesionUsuario.usuario.userId,
    //     //         OptionId: SubModuloId,
    //     //         Action: AccionesUsuario.Consultar
    //     //     }
    //     // };
    //     // const response = await ObtenerListadoCamposDinamicosRadios(Params);
    //     // if (response.status === 200) //si la respuesta fue existosa
    //     // {
    //     //     //console.log("radios", response.data);
    //     //     setListado(response.data[0]?.fieldList);
    //     // } else {
    //     //     if (response.data.errors) {
    //     //         const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
    //     //         MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
    //     //     } else {
    //     //         MostrarMensaje(dispatch, 'error', [response.statusText]);
    //     //     }
    //     //     setListado([]);
    //     // }
    //     const response = await ObtenerListadoRegistrosGenericos(campoX.listRecords, '', sesionUsuario.usuario.companyId, sesionUsuario.usuario.userId, '', true, campoX.customTableId, campoX.customTableColumnName, customEntityId)
    //     if (response.status === 200) {
    //         setListado(response.data);
    //     } else {
    //         if (response.data.errors) {

    //             const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
    //             //revisado ok
    //             MostrarMensaje(dispatch, response.data.typeError, arrayErrores);

    //         } else {
    //             MostrarMensaje(dispatch, 'error', [response.statusText]);
    //         }
    //         setListado([]);
    //     }
    // }
    else if (campoX.typeField === "CHECK") {
      setCheck(campoX.dataField === "1");
    }
  };

  return (
    <React.Fragment>
      {campoX.typeField === "CHECK" ? (
        <div
          style={{
            padding: "0px",
            margin: "0px",
            width: "100%",
            display: "inline-block",
          }}
        >
          {creaComponenteInput(
            campoX,
            setCampoX,
            CampoDinamico,
            listado,
            check,
            setCheck
          )}
          <Typography
            variant="subtitle2"
            name={campoX.fieldId}
            style={{
              fontSize: 16,
              marginBottom: 0,
              fontWeight: "normal",
              display: "inline-block",
            }}
          >
            {campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
          </Typography>
        </div>
      ) : (
        creaComponenteInput(
          campoX,
          setCampoX,
          CampoDinamico,
          listado,
          check,
          setCheck,
          IdRelacionado
        )
      )}
    </React.Fragment>
  );
};

const creaComponenteInput = (
  campoX,
  setCampoX,
  CampoDinamico,
  listFiels,
  check,
  setCheck,
  IdRelacionado = null
) => {
  const [formatoFecha, setFormatoFecha] = useState("dd/MM/yyyy");

  useEffect(() => {
    setFormatoFecha(getFormatDateLocalStorage());
  }, []);

  const ingresarValoresMemoria = (e) => {
    const { value } = e.target; // se desestructura del targen el nombre y el valor que trae
    // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el
    // valor que se le envia lo demas se queda igual
    setCampoX((anterior) => ({
      ...anterior,
      ["dataField"]: value,
    }));
    CampoDinamico.dataField = value;
  };

  const ingresarValoresMemoriaMultiList = (e) => {
    const { value } = e.target; // se desestructura del targen el nombre y el valor que trae

    // const finalValue = typeof value === 'string' ? value.split(',') : value;
    const finalValue = value.filter((item) => item !== "");

    setCampoX((anterior) => ({
      ...anterior,
      ["dataField"]: finalValue,
    }));

    const valueString = finalValue.join(",");
    CampoDinamico.dataField = valueString;
  };

  const ingresarValoresMemoriaCheck = (e) => {
    const { checked } = e.target; // se desestructura del targen el nombre y el valor que trae
    // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el
    // valor que se le envia lo demas se queda igual
    setCampoX((anterior) => ({
      ...anterior,
      ["dataField"]: checked,
    }));
    setCheck(checked);
    CampoDinamico.dataField = checked.toString();
  };

  const ingresarValoresMemoriaFecha = (e) => {
    let newValueCampo = e === null ? "" : e;
    setCampoX((anterior) => ({
      ...anterior,
      ["dataField"]: newValueCampo,
    }));
    CampoDinamico.dataField = newValueCampo;
  };

  const ingresarValoresMemoriaNumericos = (e) => {
    const { value } = e.target; // se desestructura del targen el nombre y el valor que trae

    let valorfinal = value;

    // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el
    // valor que se le envia lo demas se queda igual
    setCampoX((anterior) => ({
      ...anterior,
      ["dataField"]: valorfinal,
    }));
    CampoDinamico.dataField = valorfinal;
  };

  if (campoX.typeField === "SHT_TEXT") {
    return campoX.pattern !== "" ? (
      <InputMask
        id={campoX.fieldId}
        name={campoX.fieldName}
        mask={campoX.pattern}
        value={campoX.dataField}
        onChange={ingresarValoresMemoria}
        disabled={false}
        maskChar=" "
      >
        {() => (
          <TextField
            /*required={campoX.isRequired}*/
            variant="outlined"
            fullWidth
            label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
            inputProps={{ maxLength: campoX.maxlength }}
          />
        )}
      </InputMask>
    ) : (
      <TextField
        id={campoX.fieldId}
        name={campoX.fieldName}
        value={campoX.dataField}
        onChange={ingresarValoresMemoria}
        /*required={campoX.isRequired}*/
        label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
        variant="outlined"
        fullWidth
        inputProps={{ maxLength: campoX.maxlength }}
      />
    );
  } else if (campoX.typeField === "EMAIL") {
    return (
      <TextField
        name={campoX.fieldName}
        /*required={campoX.isRequired}*/
        id={campoX.fieldId}
        value={campoX.dataField}
        onChange={ingresarValoresMemoria}
        variant="outlined"
        fullWidth
        label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
        inputProps={{ maxLength: campoX.maxlength }}
      />
    );
  } else if (campoX.typeField === "LRG_TEXT") {
    return (
      <TextField
        /*required={campoX.isRequired}*/
        id={campoX.fieldId}
        name={campoX.fieldName}
        value={campoX.dataField}
        variant="outlined"
        multiline
        rows={2}
        fullWidth
        label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
        onChange={ingresarValoresMemoria}
        inputProps={{
          maxLength: campoX.maxlength,
        }}
      ></TextField>
    );
  } else if (campoX.typeField === "FIX_TEXT") {
    return (
      <Typography
        id={campoX.fieldId}
        variant="caption"
        fullWidth
        style={{
          fontSize: 16,
          color: "rgba(0, 0, 0, 0.60)",
          fontWeight: 400,
        }}
      >
        {campoX.fieldDescrp}
      </Typography>
    );
  } else if (campoX.typeField === "WHL_NUM") {
    return (
      <TextField
        name={campoX.fieldName}
        /*required={campoX.isRequired}*/
        id={campoX.fieldId}
        type="number"
        value={campoX.dataField}
        onChange={ingresarValoresMemoriaNumericos}
        variant="outlined"
        fullWidth
        label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
        InputProps={{
          inputProps: { min: campoX.minimum, max: campoX.maximum },
        }}
        InputLabelProps={{
          shrink: true,
        }}
      />
    );
  } else if (campoX.typeField === "DEC_NUM") {
    return (
      <TextField
        name={campoX.fieldName}
        /*required={campoX.isRequired}*/
        id={campoX.fieldId}
        type="number"
        value={campoX.dataField}
        onChange={ingresarValoresMemoriaNumericos}
        variant="outlined"
        fullWidth
        label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
        InputProps={{
          inputProps: {
            min: campoX.minimum,
            max: campoX.maximum,
            step: campoX.decimal,
          },
        }}
        InputLabelProps={{
          shrink: true,
        }}
      />
    );
  } else if (campoX.typeField === "DATE") {
    return (
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        locale={idioma === "ES" ? es : ""}
      >
        <DesktopDatePicker
          format="YYYY-MM-DD"
          /*required={campoX.isRequired}*/
          inputFormat={formatoFecha}
          id={campoX.fieldId}
          name={campoX.fieldName}
          value={campoX.dataField === "" ? null : campoX.dataField}
          variant="outlined"
          label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
          onChange={(newValue) => {
            ingresarValoresMemoriaFecha(newValue);
          }}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        {/*required={campoX.isRequired}*/}
        {/*minDate={new Date('1938-01-01')}*/}
        {/*maxDate={new Date()}*/}
      </LocalizationProvider>
    );
  } else if (campoX.typeField === "HOUR") {
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <TimePicker
          id={campoX.fieldId}
          /*required={campoX.isRequired}*/
          name={campoX.fieldName}
          value={campoX.dataField === "" ? null : campoX.dataField}
          label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
          onChange={(newValue) => {
            ingresarValoresMemoriaFecha(newValue);
          }}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
      </LocalizationProvider>
    );
  } else if (campoX.typeField === "RADIO") {
    // return
    // <FormControl fullWidth variant="outlined">
    //     <RadioGroup id={campoX.fieldId} name={campoX.fieldName} value={campoX.dataField} onChange={ingresarValoresMemoria} row>
    //         {
    //             listFiels.map((record) => (<FormControlLabel key={"ident-" + record.fieldId} value={record.value.toUpperCase()} control={<Radio />} label={record.fieldDescrp} />))
    //         }
    //     </RadioGroup>
    // </FormControl>
    return (
      <FormControl
        fullWidth
        variant="outlined"
        required={campoX.isRequired}
        sx={{
          position: "relative",
          width: "100%",
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: "4px",
          padding: "16px 14px 8px",
          boxSizing: "border-box",
          "&:hover": {
            borderColor: "rgba(0, 0, 0, 0.87)",
          },
        }}
      >
        <FormLabel
          id={`radio-${campoX.fieldId}-label`}
          sx={{
            position: "absolute",
            top: "-12px",
            left: "8px",
            backgroundColor: "white",
            padding: "0 4px",
            fontSize: "0.875rem",
          }}
        >
          {campoX.fieldDescrp}
        </FormLabel>
        <RadioGroup
          id={campoX.fieldId}
          name={campoX.fieldName}
          value={campoX.dataField}
          onChange={ingresarValoresMemoria}
          row
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            width: "100%",
            "& .MuiFormControlLabel-root": {
              margin: 0,
              minWidth: "auto",
              flex: "1 1 auto",
            },
          }}
        >
          {listFiels.map((record) => (
            <FormControlLabel
              key={"ident-" + record.id}
              value={record.id}
              control={<Radio />}
              label={record.description}
              sx={{
                margin: 0,
                "& .MuiFormControlLabel-label": {
                  fontSize: "0.875rem",
                },
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    );
  } else if (campoX.typeField === "CHECK") {
    return (
      <Checkbox
        id={campoX.fieldId}
        checked={check}
        onChange={ingresarValoresMemoriaCheck}
        color="primary"
        inputProps={{ "aria-label": "secondary checkbox" }}
      />
    );
  } else if (campoX.typeField === "LIST") {
    return (
      <FormControl fullWidth variant="outlined">
        <InputLabel id={campoX.fieldId + "-label"}>
          {campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
        </InputLabel>
        <Select
          id={campoX.fieldId}
          /*required={campoX.isRequired}*/
          name={campoX.fieldName}
          value={campoX.dataField}
          onChange={ingresarValoresMemoria}
          label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
          labelId={campoX.fieldId + "-label"}
        >
          {listFiels.map((record) => (
            <MenuItem key={"ident-" + record.id} value={record.id}>
              {record.description}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  } else if (campoX.typeField === "MULT_LIST") {
    //al crear el campo, el valor inicial es siempre un string y es necesario un array en el value, por eso se le hace split.
    const arrayValue = campoX.dataField.toString().split(",");

    return (
      <FormControl fullWidth variant="outlined">
        <InputLabel id={campoX.fieldId + "-label"}>
          {campoX.fieldDescrp + (campoX.isRequired ? " *C" : "")}
        </InputLabel>
        <Select
          id={campoX.fieldId}
          /*required={campoX.isRequired}*/
          labelId={campoX.fieldId + "-label"}
          multiple
          name={campoX.fieldName}
          value={arrayValue}
          onChange={ingresarValoresMemoriaMultiList}
          // label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
          input={
            <OutlinedInput
              label={campoX.fieldDescrp + (campoX.isRequired ? " *" : "")}
            />
          }
        >
          {listFiels.map((record) => (
            <MenuItem key={"ident-" + record.id} value={record.id}>
              {record.description}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  } else if (campoX.typeField === "DOC") {
    return (
      <BaseFieldUpload
        campoX={campoX}
        ownerEntity={IdRelacionado}
        onChange={ingresarValoresMemoria}
        formatsAllowed=".pdf,.doc,.docx"
      />
    );
  } else if (campoX.typeField === "IMG") {
    return (
      <BaseFieldUpload
        campoX={campoX}
        ownerEntity={IdRelacionado}
        onChange={ingresarValoresMemoria}
        formatsAllowed="image/*"
      />
    );
  }
};

const BaseFieldUpload = ({
  campoX,
  ownerEntity,
  onChange,
  formatsAllowed = "*/*",
}) => {
  const [{ etiquetasIdioma, sesionUsuario }, dispatch] = useStateValue();

  const {
    fieldId,
    fieldName,
    fieldDescrp,
    isRequired,
    dataField: value,
  } = campoX;

  const [selectedFile, setSelectedFile] = useState(null);

  const [isWaiting, setIsWaiting] = useState(false);

  // const handleFileChange = (event) => {
  //     const file = event.target.files[0];
  //     setSelectedFile(file);
  // };

  const guardarDataArchivo = async (e) => {
    const fileInfo = await RutinaLeerArchivoInputFile(e);
    const CodigoValidacion = "Attach_dynamic_fields_";
    if (CodigoValidacion !== "") {
      const dataObject = {
        ElementId: ownerEntity,
        MimeType: fileInfo.tipo,
        ValidateCode: CodigoValidacion,
      };

      ValidarFormatoArchivo(dataObject).then((response) => {
        if (response.status === 200) {
          //si la respuesta fue existosa
          if (response.data === true) {
            setSelectedFile(fileInfo);
            const { name, value } = e.target;
            const newEvent = { target: { name, value: fileInfo.nombre } };

            onChange(newEvent);
          } else {
            // InicializarDialogo();
            setSelectedFile(null);
            MostrarMensaje(dispatch, "warning", ["FormartFileError"]);
          }
        } else {
          if (response.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
              response.data.errors
            );
            //revisado ok
            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
          } else {
            MostrarMensaje(dispatch, "error", [response.statusText]);
          }
        }
      });
    } else {
      setFile(fileInfo);
      setFileName(fileInfo.nombre);
    }
  };

  const SubirArchivoServidor = async (e) => {
    setIsWaiting(true); // Mostrar loading antes de la petición

    const dataObject = {
      FileType: selectedFile.tipo,
      FileContent: selectedFile.contenido,
      FileSize: selectedFile.tamano,
      FileName: selectedFile.nombre,
      ObjectId: ownerEntity,
      FolderName: "DynamicFields",
      CompanyId: sesionUsuario.usuario.companyId,
      UserId: sesionUsuario.usuario.userId,
    };

    try {
      const response = await SubirArchivosServidor(dataObject);
      if (response.status === 201) {
        MostrarMensaje(dispatch, "success", [
          "Archivo subido satisfactoriamente.",
        ]);
      } else {
        eliminarAdjunto({});
        if (response.status === 401) {
          MostrarMensaje(dispatch, "error", ["ErrorFile401"]);
        } else if (response.status === 409) {
          MostrarMensaje(dispatch, "warning", ["ErrorFile409"]);
        } else if (response.status === 500) {
          MostrarMensaje(dispatch, "error", ["InternalServerError"]);
        } else if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      }
    } catch (error) {
      MostrarMensaje(dispatch, "error", [
        error.message || "Error al subir archivo",
      ]);
    } finally {
      setIsWaiting(false); // Ocultar loading después de la petición
    }
  };

  const descargarArchivo = () => {
    setIsWaiting(true); // Mostrar loading antes de la petición

    const dataObject = {
      FileName: value ?? selectedFile?.nombre,
      FolderName: "DynamicFields",
      ObjectId: ownerEntity,
      CompanyId: sesionUsuario.usuario.companyId,
      UserId: sesionUsuario.usuario.userId,
    };

    BajarArchivosServidor(dataObject)
      .then((response) => {
        if (response.status === 200) {
          DescargarArchivoBase64(
            dataObject.FileName,
            "",
            "data:" + null + ";base64," + response.data
          );
        } else if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      })
      .finally(() => {
        setIsWaiting(false); // Ocultar loading después de la petición
      });
  };

  const eliminarArchivoServidor = async (e) => {
    const dataObject = {
      FileName: value ?? selectedFile?.nombre,
      FolderName: "DynamicForms",
      ObjectId: ownerEntity,
      CompanyId: sesionUsuario.usuario.companyId,
      UserId: sesionUsuario.usuario.userId,
    };
    setIsWaiting(true);
    try {
      const response = await EliminarArchivosServidor(dataObject);
      if (response.status === 200) {
        eliminarAdjunto(e);
        MostrarMensaje(dispatch, "success", [
          "Archivo eliminado satisfactoriamente.",
        ]);
      } else if (response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        MostrarMensaje(dispatch, "error", [response.statusText]);
      }
    } catch (error) {
      MostrarMensaje(dispatch, "error", [
        error.message || "Error al eliminar archivo",
      ]);
    } finally {
      setIsWaiting(false);
    }
  };

  const eliminarAdjunto = (e = {}) => {
    setSelectedFile(null);
    const newEvent = { ...e, target: { name: fieldName, value: "" } };
    // guardarDataArchivo(newEvent);
    onChange(newEvent);
  };

  useEffect(() => {
    if (selectedFile !== null) {
      SubirArchivoServidor();
    }
  }, [selectedFile]);

  return (
    <>
      <input
        type="file"
        accept={formatsAllowed ?? "*/*"}
        style={{ display: "none" }}
        id={"hidden-image-input_" + fieldName}
        // onChange={handleFileChange}
        onChange={guardarDataArchivo}
        name={fieldName}
      />
      <TextField
        fullWidth
        name={fieldName}
        label={fieldDescrp}
        value={selectedFile ? selectedFile.nombre : value}
        required={isRequired}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {isWaiting ? (
                <CircularProgress color="inherit" />
              ) : selectedFile !== null || value !== "" ? (
                <>
                  <Tooltip title="Descargar Adjunto">
                    <IconButton
                      component="span"
                      color="primary"
                      aria-label="subir archivo"
                      onClick={descargarArchivo}
                    >
                      {/* <FileDownloadIcon /> */}
                      <CloudDownloadOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Eliminar Adjunto">
                    <IconButton
                      component="span"
                      color="primary"
                      aria-label="subir archivo"
                      onClick={(e) => eliminarArchivoServidor(e)}
                    >
                      <ClearOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <label htmlFor={"hidden-image-input_" + fieldName}>
                  <Tooltip title="Subir Adjunto">
                    <IconButton
                      component="span"
                      color="primary"
                      aria-label="subir archivo"
                    >
                      {/* <UploadFileIcon /> */}
                      {/* <CloudDownloadIcon /> */}
                      <BackupOutlinedIcon />
                      {/* <AttachFileIcon /> */}
                    </IconButton>
                  </Tooltip>
                </label>
              )}
            </InputAdornment>
          ),
        }}
        variant="outlined"
        disabled
      />
    </>
  );
};

export default InputsField;
